import React from 'react';
import useOptionsLookupCount, { LookupCountObject } from '../customFields/hooks/useOptionsLookupCount';
import useResourceLoader from '../../util/useResourceLoader';

export type BadgeElement = {
  lookup: LookupCountObject
}

function Badge({
  element: { lookup },
  scope,
}: {
  element: BadgeElement,
  scope: any
}){
  const {count, loadingCount, errorLoadingCount} = useOptionsLookupCount({lookup, rootFormData: scope, path: ''});
//   if (icons) {
//     const size = propFontSize || elFontSize || icons.size;
//     const style = size ? { fontSize: size } : {};

//     return (
//       <span className={icons.base} style={style}>
//         {icons.paths.map((p, idx) => (
//           <i key={idx} className={p} />
//         ))}
//       </span>
//     );
//   } else if (icon) {
//     const size = propFontSize || elFontSize;
//     const style: React.CSSProperties = size ? { fontSize: size } : {};

//     return <i className={icon} style={style} />;
//   } else {
//     const size = propSize || elSize;
//     const style = size
//       ? {
//           width: size[0],
//           height: size[1],
//         }
//       : {};

    return (
      <span className="badge">{loadingCount ? '...' : count}</span>
    );
}

export default Badge;
